// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1MfVV","colMaxWidth":"Table_colMaxWidth__2cq7H"};